module.exports = __webpack_public_path__ + "images/539  Suite - Balcon - The Babel Community Paris Montigny Coliving (11).jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/babel/539  Suite - Balcon - The Babel Community Paris Montigny Coliving (11).jpg
// module id = 51
// module chunks = 0